<template>
    <dl v-show="visible">
        <dt>{{label}}：</dt>
        <dd v-if="mode == 'single' || mode == 'multi'">
            <el-button type="text" size="small" :class="allClassChecked" v-show="hasAll" @click="checkedAll">全部
            </el-button>
            <span v-for="(item, index) in data">
                <el-button type="text" size="small" :class="item._selectedClass" @click="active(item)"
                           :key="index">{{item[labelName]}}</el-button>
                <br v-if="index != 0 && index % 8 == 0"/>
            </span>
        </dd>
        <dd v-if="mode == 'date'">
            <el-date-picker
                    v-model="dateValue"
                    type="daterange"
                    align="left"
                    @change="dateChange"
                    size="medium"
                    placeholder="选择日期范围">
            </el-date-picker>
        </dd>
        <dd v-if="mode === 'select'">
            <el-select
                    ref="select"
                    style="width: 400px"
                    size="medium"
                    v-model="selectValue"
                    multiple
                    filterable
                    remote
                    placeholder="请输入关键词"
                    :remote-method="remoteMethod"
                    @visible-change="selectChange"
                    @remove-tag="selectChange(false)"
                    :loading="selectLoading">
                <el-option
                        v-for="item in selectOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                </el-option>
            </el-select>
        </dd>
    </dl>
</template>

<script type="text/javascript">
    import axios from 'axios'
    import _ from 'underscore'

    export default {
        data () {
            var activeClassName = 'active'
            return {
                dateValue: '',
                value: '',
                selectValue: [],
                selectLoading: false,
                selectOptions: [],
                dateFirstTime: false,
                activeClass: activeClassName,
                allClassChecked: activeClassName,
                pickerOptions: {
                    shortcuts: []
                }
            }
        },
        mounted () {
            if (this.mode === 'date') {
                this.data.forEach((item, index) => {
                    var pickerHandler = (() => {
                        var timer = item.id * 24 * 3600 * 1000
                        return (picker) => {
                            let end = new Date()
                            let start = new Date()
                            start.setTime(start.getTime() - timer)
                            picker.$emit('pick', [start, end])
                        }
                    })(item)

                    this.pickerOptions.shortcuts.push({
                        text: item.text,
                        onClick: pickerHandler
                    })
                })
                if (this.initValue) {
                    this.dateFirstTime = !!this.initValue.length
                }
            }
            this.value = this.initValue || ''
            this.setSelected()
        },
        props: {
            // 标签值的属性名
            valueName: {type: String, default: 'value'},
            // 标签文字的属性名
            labelName: {type: String, default: 'text'},
            // 过滤条件的中文
            label: String,
            name: String,
            // 多选模式(multi) or 单选模式(single) or 日期(date)
            mode: {type: String, default: 'multi'},
            // 是否有全选
            hasAll: {type: Boolean, default: true},
            // 标签的数据
            data: {
                type: Array,
                default () {
                    return []
                }
            },
            visible: {type: Boolean, default: true},
            initValue: [String, Array]
        },
        watch: {
            data: {
                handler: function () {
                    this.setSelected()
                },
                deep: true
            },
            initValue: {
                handler: function (newValue) {
                    this.setSelected(newValue)
                },
                deep: true
            }
        },
        methods: {
            active (item) {
                var isChecked = item._selectedClass === this.activeClass
                if (this.mode === 'single') {
                    this.data.forEach((item) => {
                        item._selectedClass = ''
                    })
                }
                this.allClassChecked = ''
                item._selectedClass = isChecked ? '' : this.activeClass
                this.$parent.$emit('params-change', this.name)
            },
            dateChange () {
                if (!this.dateFirstTime) {
                    this.$parent.$emit('params-change')
                } else {
                    this.dateFirstTime = false
                }
            },
            checkedAll () {
                this.data.forEach((item) => {
                    item._selectedClass = ''
                })
                this.allClassChecked = this.activeClass
                this.$parent.$emit('params-change', this.name)
            },
            getSelected () {
                let params = {}, values = []
                if (this.mode === 'single' || this.mode === 'multi') {
                    this.data.forEach((item, index) => {
                        item = this.data[index]
                        if (item._selectedClass === this.activeClass) {
                            values.push(item[this.valueName])
                        }
                    })
                } else if (this.mode === 'date') {
                    this.dateValue = this.dateValue || []
                    values = values.concat([this.formateDate(this.dateValue[0]), this.formateDate(this.dateValue[1])])
                } else if (this.mode === 'select') {
                    values = values.concat(this.selectValue)
                }
                params[this.name] = values.join(',')
                this.value = values.join(',')
                return params
            },
            setSelected (value) {
                // 如果有值则更新值
                if (value) {
                    this.value = value
                }
                if (this.mode === 'date') {
                    this.dateValue = this.value
                } else if (this.mode === 'select') {
                    this.selectValue = _.pluck(this.data, 'id')
                    this.setSelectDefaultValue(this.data)
                } else {
                    let activeClass = this.activeClass
                    this.data.forEach((item) => {
                        item._selectedClass = ''
                    })
                    if (this.value === '' || this.value === null) {
                        if (this.hasAll === true) {
                            this.allClassChecked = activeClass
                        }
                    } else {
                        let valueName = this.valueName
                        this.allClassChecked = ''
                        this.value.split(',').forEach(item => {
                            this.data.forEach(orgData => {
                                if (String(orgData[valueName]) === String(item)) {
                                    orgData._selectedClass = activeClass
                                }
                            })
                        })
                    }
                    this.$forceUpdate()
                }
            },
            formateDate (date) {
                if (date) {
                    let m = date.getMonth() + 1,
                        d = date.getDate()
                    return [date.getFullYear(), m < 10 ? '0' + m : m, d < 10 ? '0' + d : d].join('-')
                } else {
                    return ''
                }
            },
            remoteMethod (query) {
                if (query !== '') {
                    this.selectLoading = true

                    axios.get('/system/position/list.api', {params: {name: query}, 'X-loadingOff': true}).then(res => {
                        this.selectLoading = false
                        this.selectOptions = res.result.list.map(item => {
                            return {
                                value: item.id,
                                label: item.name
                            }
                        })
                    }).catch(() => {
                        this.selectLoading = false
                        this.selectOptions = []
                    })
                } else {
                    this.selectOptions = []
                }
            },

            selectChange (boolean) {
                if (!boolean) {
                    this.$parent.$emit('params-change')
                }
            },

            setSelectDefaultValue (list) {
                if (Object.prototype.toString.call(list) === '[object Array]' && list.length > 0) {
                    list.forEach(item => {
                        this.$refs.select.$data.cachedOptions.push({value: item.id, currentLabel: item.name})
                    })
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// filterPanelItem.vue?4405817d